import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { DResult } from '../models/common.models/dresult.model';
import { GalleryGroupGetListOutputDTO } from '../models/informations.models/galleryGroup.models/galleryGroupGetListOutputDTO.model';
import { GalleryGroupGetDetailOutputDTO } from '../models/informations.models/galleryGroup.models/galleryGroupGetDetailOutputDTO.model';

@Injectable()
export class GalleryGroupsSiteService {

    constructor(private http: HttpClient) {

    }

    GetList() {
        var urlAddress: string = `${API_ServerAddress}/api/v1/GalleryGroups/GetList`;
        return this.http.get<DResult<GalleryGroupGetListOutputDTO[]>>(urlAddress);
    }

    GetById(id: number) {
        var urlAddress: string = `${API_ServerAddress}/api/v1/GalleryGroups/GetById/${id}`;
        return this.http.get<DResult<GalleryGroupGetDetailOutputDTO>>(urlAddress);
    }
}
